import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowRightIcon } from 'lucide-react';
export function KontaktPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-1058">
      <Navbar data-id="element-1059" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-1060">
        <div className="max-w-6xl mx-auto" data-id="element-1061">
          <div className="text-center mb-10 md:mb-16" data-id="element-1062">
            <h1 className="text-3xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-1063">
              Kontakt & Anmeldung
            </h1>
            <p className="text-base sm:text-lg text-slate-500 max-w-2xl mx-auto font-medium" data-id="element-1064">
              Haben Sie Fragen zu unseren Kursen oder möchten Sie sich anmelden?
              Wir freuen uns auf Ihre Nachricht.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-1065">
            {/* Image Side */}
            <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] lg:aspect-auto lg:h-full sticky top-32" data-id="element-1066">
              <img src="https://cdn.rawproductionsgmbh.de/2n/kontakt/kontakt.jpg" alt="Kontakt aufnehmen" className="w-full h-full object-cover" data-id="element-1067" />
            </div>

            {/* Form Side */}
            <div className="bg-white border border-slate-200 shadow-xl rounded-3xl p-8 md:p-12" data-id="element-1068">
              <h2 className="text-2xl font-extrabold text-slate-700 mb-8" data-id="element-1069">
                Schreiben Sie uns
              </h2>
              <form className="space-y-6" data-id="element-1070">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1071">
                  <div data-id="element-1072">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1073">
                      Vorname
                    </label>
                    <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-1074" />
                  </div>
                  <div data-id="element-1075">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1076">
                      Nachname
                    </label>
                    <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-1077" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1078">
                  <div data-id="element-1079">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1080">
                      E-Mail
                    </label>
                    <input type="email" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-1081" />
                  </div>
                  <div data-id="element-1082">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1083">
                      Telefon
                    </label>
                    <input type="tel" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-1084" />
                  </div>
                </div>

                <div data-id="element-1085">
                  <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1086">
                    Betreff / Kursinteresse
                  </label>
                  <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" placeholder="Wofür interessieren Sie sich?" data-id="element-1087" />
                </div>

                <div data-id="element-1088">
                  <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-1089">
                    Nachricht
                  </label>
                  <textarea rows={6} className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700 resize-none" placeholder="Ihre Nachricht an uns..." data-id="element-1090"></textarea>
                </div>

                <button type="button" className="w-full bg-[#3b7780] hover:bg-[#2d5f66] text-white font-extrabold py-4 px-6 rounded-xl transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-lg" data-id="element-1091">
                  Jetzt Kursplan sichern <ArrowRightIcon className="w-5 h-5" data-id="element-1092" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1093" />
    </div>;
}